import { render, staticRenderFns } from "./header_notification.vue?vue&type=template&id=605f6a17&scoped=true"
import script from "./header_notification.vue?vue&type=script&lang=js"
export * from "./header_notification.vue?vue&type=script&lang=js"
import style0 from "./header_notification.vue?vue&type=style&index=0&id=605f6a17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f6a17",
  null
  
)

export default component.exports